import React from "react"
import styled from "styled-components"
import Hr from "styleguide/components/Hr"

const Container = styled.div`
  margin: 40px 0;
  display: flex;
  justify-content: center;
`

const MdxHr = () => (
  <Container>
    <Hr width="80px" />
  </Container>
)

export default MdxHr
